import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import { FullPublicPhotoFragmentFragment } from "src/api/graphql/__generated__/graphql";
import { create } from "zustand";

type PopUpVariant =
	| "ScrollPhotos"
	| "SeeViewers"
	| "PhotoDetail"
	| "VideoDetail"
	| "UploadPhotos"
	| "SeePhotos"
	| "FilterPhotos";
export interface GatheringPublicFullStore {
	refCode: string;
	gatheringId: string;
	gatheringName: string | undefined;
	privacy: GatheringPrivacy[];
	photosMode: "All" | "Top";
	hasTopPhotos: boolean;
	headerPhotos: FullPublicPhotoFragmentFragment[];
	handleJoinGathering: () => void;
	joinLoading: boolean;
	popUpVariant: null | PopUpVariant;
	setPopUpVariant: (variant: null | PopUpVariant) => void;
	didFilterScrollPopup: boolean;
	setDidFilterScrollPopup: (didFilterScrollPopup: boolean) => void;
}

export const createGatheringPublicFullStore = (
	initial: Pick<
		GatheringPublicFullStore,
		| "refCode"
		| "gatheringId"
		| "handleJoinGathering"
		| "joinLoading"
		| "gatheringName"
		| "privacy"
	>,
) => {
	return create<GatheringPublicFullStore>((set) => ({
		popUpVariant: null,
		setPopUpVariant: (variant) => set({ popUpVariant: variant }),
		photosMode: "All",
		hasTopPhotos: false,
		headerPhotos: [],
		didFilterScrollPopup: false,
		setDidFilterScrollPopup: (didFilterScrollPopup) => set({ didFilterScrollPopup }),
		...initial,
	}));
};
